module.exports = __webpack_public_path__ + "static/the-divide-lives-on.ad3c0a05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/the-divide-lives-on.png
// module id = 1347
// module chunks = 275850137669291